<app-material>
    <div class="header" header>
        <div class="title">
            <h2>{{ 'atom.tool-requests-lines.process.title' | translate }}</h2>
            <div class="mutators">
                <app-icon class="expand" library="material"
                          variant="{{this.allExpanded ? 'keyboard_arrow_up': 'keyboard_arrow_down' }}"
                          (click)="toggleExpanded()"></app-icon>
                <app-icon library="material" variant="filter_list" (click)="toggleFilters()"></app-icon>
            </div>
        </div>
        <section *ngIf="selectedToolRequestDetails"
                 class="tool-request-details">
            <app-display-label
                label="{{'atom.tool-requests-facilities.process.labels.toolRequestName' | translate}}"
                [value]="selectedToolRequestDetails?.name"></app-display-label>
            <app-display-label
                label="{{'atom.tool-requests-facilities.process.labels.dateRequested' | translate}}"
                [value]="selectedToolRequestDetails?.createdDate"></app-display-label>
            <app-display-label
                label="{{'atom.tool-requests-facilities.process.labels.createdBy' | translate}}"
                [value]="selectedToolRequestDetails?.createdBy?.fullName"></app-display-label>
            <app-display-label
                label="{{'atom.tool-requests-facilities.process.labels.facility' | translate}}"
                [value]="selectedToolRequestDetails?.facility?.name"></app-display-label>
        </section>
    </div>
    <div class="body" body>
        <section *ngIf="selectedToolRequestTools" class="tools-section">
            <app-tool-request-facilities-tools-table
                *ngIf="selectedToolRequestDetails"
                [rowExpand]="true"
                [tools]="selectedToolRequestTools"
                [showFilters]="showFilters"
                [isLoading]="isLoading"
                [tableConfig]="tableConfig"
                (sortChange)="onSortChange($event)"
                (filterChange)="onFilter($event)"
                (pageChange)="onPageChange($event)">
            </app-tool-request-facilities-tools-table>
        </section>
    </div>
    <div *ngIf="selectedToolRequestDetails" class="footer" footer>
        <app-button
            type="simple"
            class="back"
            (clicked)="onBack()">{{
                'generic.buttons.back' |
                    translate
            }}
        </app-button>
        <app-button
            type="primary"
            [disabled]="hasConfirmationInProgress"
            (clicked)="approveToolRequest()">{{
                'generic.buttons.approve' | translate
            }}
        </app-button>
    </div>
</app-material>
